<template>
    <head>
        <link
            href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700&display=swap"
            rel="stylesheet"
        />
    </head>

    <v-app id="app">
        <main>
            <slot />
        </main>
        <!-- <div class="mx-auto w-[90%] min-w-[290px] max-w-[1170px]">
            <main>
                <slot />
            </main>
        </div> -->
    </v-app>
</template>

<script>
import AppHeader from "@/Components/Campaigns/AppHeader";
import AppFooter from "@/Components/Campaigns/AppFooter";

export default {
    components: {
        AppHeader,
        AppFooter,
    },
};
</script>

<style>
body {
    font-family: Poppins !important;
}

#app {
    background-color: #F7F9FC !important;
}

.v-field__outline__notch {
    border: none !important;
}
</style>
